export const STORAGE_IDS_KEY = 'pinnedProjects';
export const STORAGE_DATA_KEY = 'pinnedProjectsData';
export const PINNED_PROJECTS_CHANGED_EVENT = 'pinnedProjectsChanged';

export const readStoredPinnedProjects = () => {
    try {
        const ids = JSON.parse(localStorage.getItem(STORAGE_IDS_KEY) || '[]');
        const projects = JSON.parse(localStorage.getItem(STORAGE_DATA_KEY) || '[]');
        return {
            ids: Array.isArray(ids) ? ids : [],
            projects: Array.isArray(projects) ? projects.filter((project) => ids.includes(project.id)) : [],
        };
    } catch {
        return { ids: [], projects: [] };
    }
};

export const persistPinnedProjects = (projects = []) => {
    const normalizedProjects = Array.isArray(projects)
        ? projects.filter((project) => project?.id && project?.name)
        : [];
    localStorage.setItem(STORAGE_IDS_KEY, JSON.stringify(normalizedProjects.map((project) => project.id)));
    localStorage.setItem(STORAGE_DATA_KEY, JSON.stringify(normalizedProjects));
    window.dispatchEvent(new Event(PINNED_PROJECTS_CHANGED_EVENT));
};

export const clearPinnedProjects = () => {
    localStorage.removeItem(STORAGE_IDS_KEY);
    localStorage.removeItem(STORAGE_DATA_KEY);
    window.dispatchEvent(new Event(PINNED_PROJECTS_CHANGED_EVENT));
};

export const mergePinnedMetadata = (projectsList = [], pinnedIds = []) => {
    if (!pinnedIds.length) return [];

    const stored = readStoredPinnedProjects();
    const fromList = new Map(
        projectsList
            .filter((project) => pinnedIds.includes(project.id))
            .map((project) => [project.id, { id: project.id, name: project.name }]),
    );

    return pinnedIds
        .map((id) => fromList.get(id) || stored.projects.find((project) => project.id === id))
        .filter((project) => project?.id && project?.name);
};

export const hasPinnedMetadataChanged = (nextProjects, currentProjects = []) => {
    if (nextProjects.length !== currentProjects.length) return true;
    return nextProjects.some(
        (project, index) =>
            project.id !== currentProjects[index]?.id || project.name !== currentProjects[index]?.name,
    );
};
